<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div>
      <div class="uk-flex uk-flex-between uk-flex-middle">
        <div>
          <h1 class="uk-h4 uk-margin-remove">
            <span data-uk-icon="icon:user; ratio:1.2"></span>
            Händler anlegen
          </h1>
        </div>
        <div>
          <a @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-secondary">
            <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
            Zurück
          </a>
        </div>
      </div>
    </div>
    <div>
      <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
        <div class="uk-card-body">
          <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <div class="uk-grid" data-uk-grid>
              <div class="uk-width-1-2@m">
                <div class="uk-grid" uk-grid>
                  <div class="uk-width-1-1">
                    <div class="uk-margin">
                      <label class="uk-form-label" for="company">Firma</label>
                      <div class="uk-form-controls">
                        <ValidationProvider :rules="'required'" name="company" v-slot="{ errors }">
                          <input
                            class="uk-input"
                            name="company"
                            type="text"
                            v-model="form.company"
                            :class="{ 'uk-form-danger': errors[0] }"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>

                  <div class="uk-width-1-1 uk-margin-top">
                    <div class="uk-margin">
                      <label class="uk-form-label" for="street">Straße</label>
                      <div class="uk-form-controls">
                        <ValidationProvider :rules="'required'" name="street" v-slot="{ errors }">
                          <input
                            class="uk-input"
                            type="text"
                            name="street"
                            v-model="form.street"
                            :class="{ 'uk-form-danger': errors[0] }"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>

                  <div class="uk-width-1-2@m uk-margin-top">
                    <div class="uk-margin">
                      <label class="uk-form-label" for="zipcode">PLZ</label>
                      <div class="uk-form-controls">
                        <ValidationProvider :rules="'required'" name="zipcode" v-slot="{ errors }">
                          <input
                            class="uk-input"
                            id="zipcode"
                            type="text"
                            name="zipcode"
                            v-model="form.zipcode"
                            :class="{ 'uk-form-danger': errors[0] }"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="uk-margin">
                      <label for="country">Land</label>
                      <v-select
                        v-model="form.country"
                        :options="countries"
                        :clearable="false"
                        :searchable="false"
                      ></v-select>
                    </div>
                    <div class="uk-margin">
                      <label class="uk-form-label" for="phone">Telefon</label>
                      <div class="uk-form-controls">
                        <ValidationProvider :rules="'required'" name="phone" v-slot="{ errors }">
                          <input
                            class="uk-input"
                            type="text"
                            name="phone"
                            v-model="form.phone"
                            :class="{ 'uk-form-danger': errors[0] }"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>

                  <div class="uk-width-1-2@m uk-margin-top">
                    <div class="uk-margin">
                      <label class="uk-form-label" for="city">Ort</label>
                      <div class="uk-form-controls">
                        <ValidationProvider :rules="'required'" name="city" v-slot="{ errors }">
                          <input
                            class="uk-input"
                            id="city"
                            type="text"
                            name="city"
                            v-model="form.city"
                            :class="{ 'uk-form-danger': errors[0] }"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="uk-margin">
                      <label class="uk-form-label" for="ustid">USt.-Id.-Nr./VAT</label>
                      <div class="uk-form-controls">
                        <ValidationProvider :rules="'required'" name="ustid" v-slot="{ errors }">
                          <input
                            class="uk-input"
                            id="ustid"
                            type="text"
                            name="ustid"
                            v-model="form.ustid"
                            :class="{ 'uk-form-danger': errors[0] }"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="uk-margin">
                      <label class="uk-form-label" for="fax">Fax</label>
                      <div class="uk-form-controls">
                        <input
                          class="uk-input"
                          id="fax"
                          type="text"
                          name="fax"
                          v-model="form.fax"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="uk-width-1-2@m">
                <h5 class="uk-text-bold">Ansprechpartner</h5>
                <div class="uk-grid uk-grid-small" data-uk-grid>
                  <div class="uk-width-1-2@m">
                    <div class="uk-margin">
                      <label class="uk-form-label" for="firstname">Anrede</label>
                      <div class="uk-form-controls">
                        <ValidationProvider
                          :rules="'required'"
                          name="salutation"
                          v-slot="{ errors }"
                        >
                          <select
                            class="uk-select"
                            v-model="form.salutation"
                            :class="{ 'uk-form-danger': errors[0] }"
                          >
                            <option value="Herr">Herr</option>
                            <option value="Frau">Frau</option>
                          </select>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="uk-grid uk-grid-small" data-uk-grid>
                  <div class="uk-width-1-2@m">
                    <div class="uk-margin">
                      <label class="uk-form-label" for="firstname">Vorname</label>
                      <div class="uk-form-controls">
                        <ValidationProvider
                          :rules="'required'"
                          name="firstname"
                          v-slot="{ errors }"
                        >
                          <input
                            class="uk-input"
                            id="firstname"
                            name="firstname"
                            type="text"
                            v-model="form.firstname"
                            :class="{ 'uk-form-danger': errors[0] }"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                  <div class="uk-width-1-2@m">
                    <div class="uk-margin">
                      <label class="uk-form-label" for="lastname">Nachname</label>
                      <div class="uk-form-controls">
                        <ValidationProvider :rules="'required'" name="lastname" v-slot="{ errors }">
                          <input
                            class="uk-input"
                            id="lastname"
                            type="text"
                            name="lastname"
                            v-model="form.lastname"
                            :class="{ 'uk-form-danger': errors[0] }"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                  <div class="uk-width-1-2@m">
                    <div class="uk-margin">
                      <label class="uk-form-label" for="email">E-Mail Adresse</label>
                      <div class="uk-form-controls">
                        <ValidationProvider
                          :rules="'required|email'"
                          name="email"
                          v-slot="{ errors }"
                        >
                          <input
                            class="uk-input"
                            id="email"
                            type="text"
                            name="email"
                            v-model="form.email"
                            :class="{ 'uk-form-danger': errors[0] }"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                  <div class="uk-width-1-2@m">
                    <div class="uk-margin">
                      <label class="uk-form-label" for="mobile">Mobil</label>
                      <div class="uk-form-controls">
                        <input
                          class="uk-input"
                          id="mobile"
                          type="text"
                          name="mobile"
                          v-model="form.mobile"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="uk-width-1-1">
                <div class="uk-align-right">
                  <label>
                    <input type="checkbox" class="uk-checkbox" v-model="form.active" /> Händler
                    aktivieren
                  </label>
                  <button
                    type="submit"
                    class="uk-button uk-button-primary uk-margin-small-left"
                    :disabled="isSending"
                    @click.prevent="handleSubmit(store)"
                  >
                    <div
                      v-if="isSending"
                      data-uk-spinner="ratio: 0.7"
                      class="uk-margin-small-right"
                    ></div>
                    Senden
                  </button>
                </div>
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MerchantService from '@/services/merchant.service'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'Pflichtfeld'
})

extend('email', {
  ...email
})

export default {
  data() {
    return {
      countries: [
        'Deutschland',
        'Österreich',
        'Schweiz',
        'Belgien',
        'Polen',
        'Dänemark',
        'Bulgarien',
        'Estland',
        'Finnland',
        'Frankreich',
        'Griechenland',
        'Grossbritannien',
        'Holland',
        'Italien',
        'Irland',
        'Kroatien',
        'Lettland',
        'Litauen',
        'Luxemburg',
        'Malta',
        'Norwegen',
        'Portugal',
        'Rumänien',
        'Schweden',
        'Slowakei',
        'Slowenien',
        'Spanien',
        'Tschechien',
        'Ungarn',
        'Zypern'
      ],
      isSending: false,
      form: {
        company: '',
        firstname: '',
        lastname: '',
        ustid: '',
        street: '',
        zipcode: '',
        country: 'Deutschland',
        phone: '',
        fax: '',
        city: '',
        mobile: '',
        email: '',
        salutation: 'Herr',
        active: true
      }
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  mounted() {
    //
  },
  methods: {
    async store() {
      this.isSending = true
      try {
        await MerchantService.create(this.form)
        iziToast.success({
          title: 'OK',
          message: 'Händer angelegt!',
          timeout: 3000,
          position: 'topCenter'
        })
        this.isSending = false
        //this.$router.push({ name: 'admin.merchant.details', params: { id: response.data.id } })
        this.$router.push({ name: 'admin.merchant' })
      } catch (error) {
        this.isSending = false
        let message = 'Es ist ein Fehler aufgetreten!'
        if(error.response.status === 400) {
          message = error.response.data.message
        }
        iziToast.error({
          title: 'Fehler',
          message: message,
          timeout: 5000,
          position: 'topCenter'
        })
      }
    }
  }
}
</script>
